import { HostedGamesService } from '@hosted-games/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RemoveGamePlayerPathParams } from '@core-http';
import { RemovePlayerCommandPayload } from './remove-player.command-payload';

export class RemovePlayerCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);

  remove(payload: RemovePlayerCommandPayload): Observable<void> {
    const pathParams: RemoveGamePlayerPathParams = {
      hostedGameId: payload.gameId,
      gamePlayerId: payload.playerId
    };

    return this.hostedGamesService.removePlayer(pathParams, payload.removalReason);
  }
}
